// extracted by mini-css-extract-plugin
export var badgeActiveFilter = "BadgeActiveFilter_badgeActiveFilter__eiGeJ";
export var btnClose = "BadgeActiveFilter_btnClose__uC2OK";
export var rotate = "BadgeActiveFilter_rotate__3I4C0";
export var dotty = "BadgeActiveFilter_dotty__x7G9W";